import React, { useEffect, useState } from "react";
import api from "@/lib/api";

function daysBack(n) {
  const arr = [];
  const today = new Date();
  for (let i = n - 1; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    arr.push(d.toISOString().slice(0, 10));
  }
  return arr;
}

export default function StreakCalendar() {
  const [data, setData] = useState({});
  useEffect(() => {
    api.get("/calendar").then((r) => setData(r.data)).catch(() => {});
  }, []);
  const days = daysBack(90);
  return (
    <div data-testid="streak-calendar" className="w-full">
      <div className="grid grid-cols-[repeat(15,minmax(0,1fr))] sm:grid-cols-[repeat(30,minmax(0,1fr))] gap-1">
        {days.map((d) => {
          const count = data[d] || 0;
          const intensity =
            count === 0 ? "bg-slate-800/40" :
            count <= 3 ? "bg-cyan-900/60" :
            count <= 6 ? "bg-cyan-600/70" :
            count <= 10 ? "bg-cyan-400/80" :
            "bg-cyan-300 shadow-[0_0_8px_rgba(0,229,255,0.7)]";
          return (
            <div
              key={d}
              title={`${d} — ${count} quests`}
              className={`aspect-square ${intensity} border border-white/5`}
            />
          );
        })}
      </div>
      <div className="mt-3 flex items-center gap-2 text-[0.65rem] text-slate-500 font-mono-tech">
        <span>less</span>
        <div className="w-3 h-3 bg-slate-800/40 border border-white/5" />
        <div className="w-3 h-3 bg-cyan-900/60 border border-white/5" />
        <div className="w-3 h-3 bg-cyan-600/70 border border-white/5" />
        <div className="w-3 h-3 bg-cyan-400/80 border border-white/5" />
        <div className="w-3 h-3 bg-cyan-300" />
        <span>more</span>
      </div>
    </div>
  );
}
